import type { ChainConfig } from "./types";

export const SEPOLIA_CHAIN_ID = 11155111;

const SEPOLIA_RPC_URL =
  "https://damp-greatest-ensemble.ethereum-sepolia.quiknode.pro/181816e3606c96014a5cfbac3eedb823d79dde08/";
const SEPOLIA_RPC_FALLBACK_URL = "https://ethereum-sepolia-rpc.publicnode.com";

/** Underlying ERC-20s from deployConfig.testnet.yaml (Sepolia v0.2). */
const WETH = "0x7b79995e5f793A07Bc00c21412e50Ecae098E7f9";
const USDC = "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238";
const MTT = "0x9d66a840ca06e3b2abbb71447c3bb6627bf64dbe";

/** Deployed PoD portal pairs from pod-ecosystem-integration deployConfig.testnet.yaml (Sepolia v0.2). */
const P_ETH = "0xe315cf5e70c2A60079eBF8f2557e633927E32045";
const P_USDC = "0xefC84043f413907d2DB15067c405650eCB67Fd92";
const P_MTT = "0x59b28A457aF96dD3904fa8f95E8A3A1e73EC8115";
const PORTAL_ETH = "0xe2691bC338677039829AAF3618b3b31CA8050572";
const PORTAL_USDC = "0x6b4B0c9e0521aB52DFdc7813C2A08C75Bcf26c98";
const PORTAL_MTT = "0x9BB9A50F69fc2EF007F509ee10bD0afae82c3108";
const PRIVACY_PORTAL_FACTORY = "0x621756245828dda9ab40da93f7b19113a5211cec";

export const sepoliaChain: ChainConfig = {
  id: SEPOLIA_CHAIN_ID,
  hexId: "0xaa36a7",
  name: "Sepolia",
  rpcUrl: SEPOLIA_RPC_URL,
  rpcFallbackUrls: [SEPOLIA_RPC_FALLBACK_URL],
  explorerBaseUrl: "https://eth-sepolia.blockscout.com",
  unlockStrategy: "manual-aes-key",
  portalStrategy: "pod-privacy-portal",
  podFeeEstimation: {
    deposit: { forwardGasLimit: 850_000n, callBackGasLimit: 2_000_000n },
    withdraw: { forwardGasLimit: 900_000n, callBackGasLimit: 2_000_000n },
    // forwardDataSize matches PodERC20.FEE_ESTIMATE_REMOTE_CALL_SIZE (encrypted itUint256).
    transfer: {
      forwardGasLimit: 850_000n,
      callBackGasLimit: 2_000_000n,
      forwardDataSize: 512n,
    },
  },
  priceOracleAddress: "0xc4c0e50cc3307f6ece9f9cbd7c520a67319cae06",
  addresses: {
    MTT,
    WETH,
    USDC,
    "p.MTT": P_MTT,
    "p.USDC": P_USDC,
    "p.ETH": P_ETH,
    PrivacyPortalMTT: PORTAL_MTT,
    PrivacyPortalUSDC: PORTAL_USDC,
    PrivacyPortalETH: PORTAL_ETH,
    PrivacyPortalFactory: PRIVACY_PORTAL_FACTORY,
  },
  tokens: [
    {
      symbol: "MTT",
      name: "MyTestToken",
      icon: "/icons/coti.svg",
      decimals: 18,
      isPrivate: false,
      addressKey: "MTT",
      bridgeAddressKey: "PrivacyPortalMTT",
      supportedChainIds: [SEPOLIA_CHAIN_ID],
    },
    {
      symbol: "p.MTT",
      name: "Private MyTestToken",
      icon: "/icons/coti.svg",
      decimals: 18,
      isPrivate: true,
      addressKey: "p.MTT",
      bridgeAddressKey: "PrivacyPortalMTT",
      supportedChainIds: [SEPOLIA_CHAIN_ID],
    },
    {
      symbol: "USDC",
      name: "USD Coin",
      icon: "/icons/USDC.svg",
      decimals: 6,
      isPrivate: false,
      addressKey: "USDC",
      bridgeAddressKey: "PrivacyPortalUSDC",
      supportedChainIds: [SEPOLIA_CHAIN_ID],
    },
    {
      symbol: "p.USDC",
      name: "Private USDC",
      icon: "/icons/USDC.svg",
      decimals: 6,
      isPrivate: true,
      addressKey: "p.USDC",
      bridgeAddressKey: "PrivacyPortalUSDC",
      supportedChainIds: [SEPOLIA_CHAIN_ID],
    },
    {
      symbol: "ETH",
      name: "Ether",
      icon: "/icons/wETH.svg",
      decimals: 18,
      isPrivate: false,
      isNative: true,
      addressKey: "WETH",
      bridgeAddressKey: "PrivacyPortalETH",
      supportedChainIds: [SEPOLIA_CHAIN_ID],
    },
    {
      symbol: "p.ETH",
      name: "Private WETH",
      icon: "/icons/wETH.svg",
      decimals: 18,
      isPrivate: true,
      addressKey: "p.ETH",
      bridgeAddressKey: "PrivacyPortalETH",
      supportedChainIds: [SEPOLIA_CHAIN_ID],
    },
  ],
  walletNetwork: {
    chainId: "0xaa36a7",
    chainName: "Sepolia",
    rpcUrls: [SEPOLIA_RPC_URL, SEPOLIA_RPC_FALLBACK_URL],
    nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
    blockExplorerUrls: ["https://eth-sepolia.blockscout.com"],
  },
  indexPage: {
    showPodRequestTracker: true,
    amountModalGasLabel: "Estimated Network Gas",
    amountModalGasSymbol: "native",
  },
};
